exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mapsg[data-v-ae27abea] {\n    height: calc(100vh - (190px));\n    display: block;\n}\n", ""]);

// exports
